import {WixSdk} from '@wix/js-sdk-wrapper';
import {BiErrorParams, reportBiError} from '../statistics/bi';
import {getWixParams} from '../statistics/getWixParams';
import {debugScoped} from '../utils/debug';
import {reportPerformanceStep} from '../widget-player/performance/report-step';
import {BI_ERRORS, IErrorDescription} from './errors';
import {fedopsLogger} from './fedops';
import {logErrorToSentry} from './sentry';

export interface AdditionalParams {
  reason?: any;

  [otherParam: string]: any;
}

const isSeenSymbol = Symbol('isSeen');

export function logError(
  errorDescription: IErrorDescription,
  additionalParams: AdditionalParams = {},
  biParams: BiErrorParams = {},
) {
  if (!errorDescription) {
    console.error('Invalid argument to log error');
    return;
  }

  if (additionalParams.reason) {
    try {
      const reason = additionalParams.reason;
      if (reason[isSeenSymbol]) {
        return;
      }
      if (typeof reason === 'object' && reason !== null) {
        Object.defineProperty(reason, isSeenSymbol, {
          enumerable: false,
          value: true,
        });
      }
    } catch (e) {
      console.error(e);
      logErrorToSentry(BI_ERRORS.genericError, {reason: e});
    }
  }

  console.error(
    `Wix Music ${getWixParams().compId} Error:\n`,
    errorDescription.name,
    additionalParams.reason || additionalParams,
    biParams,
  );
  if (errorDescription.name && errorDescription.id) {
    reportBiError(errorDescription, biParams);
  } else {
    reportBiError({id: 1999, name: 'unhandled-error'});
  }

  logErrorToSentry(errorDescription, additionalParams);
}

let playerStartedFired = false;

export function logPlayerStarted() {
  if (playerStartedFired) {
    return;
  }
  playerStartedFired = true;
  WixSdk.Performance.applicationLoaded();
  fedopsLogger.appLoaded();
  reportPerformanceStep('player-started');
  debugScoped('logging', 'app loaded');
}
